// extracted by mini-css-extract-plugin
export default {"wrap":"AboutUs_wrap__JK-UF","row":"AboutUs_row__EO2k1"};